<template>
  <div class="container">
    <My-Breadcrumb style="position: absolute; top: 80px"
                   :breadcrumbs="breadcrumbs" />
    <div class="mainBox">
      <!-- 菜单类型 -->
      <div class="show_left">
        <a-page-header style="padding-left: 0; padding-right: 0"
                       title="原料类别">
          <template slot="extra">
            <a-button type="primary"
                      icon="plus"
                      @click="showTypeModal('add')">新增类型</a-button>
          </template>
        </a-page-header>
        <a-table :columns="columnsLeft"
                 :data-source="[{id: '', title: '全部'}, ...batchingTypeData]"
                 :loading="loading"
                 :rowKey="(batchingTypeData) => batchingTypeData.id"
                 :pagination="false">
                 
          <template slot="titleRender" slot-scope="record">
            <span v-if="queryParam.batching_type_id==record.id" style="color:#1E7CFF;font-weight:bold;">{{ record.title }}</span>
            <span v-else>{{ record.title }}</span>
          </template>
          <template slot="action"
                    slot-scope="record">
                    <a-button type="link"
                      v-if="record.is_fixed == 0"
                      @click="showTypeModal(record)" class="btn-diy" >编辑</a-button>
            <a-divider type="vertical"
                       v-if="record.is_fixed == 0" />
            <a-button type="link"
                      v-if="record.is_fixed == 0"
                      @click="deleteType(record)" class="btn-diy" >删除</a-button>
            <a-divider type="vertical"
                       v-if="record.is_fixed == 0" />
            <a-button type="link"
                      @click="searchByType(record)" class="btn-diy" >查询</a-button>
          </template>
        </a-table>
      </div>
      <!-- 原料列表 -->
      <div class="show_right">
        <a-page-header style="padding-left: 0; padding-right: 0"
                       title="原料列表">
          <template slot="extra">
            <!-- <a-input placeholder="请输入原料名称"
                     v-model="queryParam.title"
                     style="width:150px;"></a-input>
            <a-button 
                      type="primary"
                      @click="handleSearch"
                      style="margin-left: 10px">搜索</a-button>
            <a-button 
                      @click="reset"
                      style="margin-left: 10px">重置</a-button> -->
            <a-button type="primary"
                      
                      @click="showModal('add')"
                      style="margin-left: 10px">添加原料</a-button>
            <!-- <a-button type="primary"
              @click="batchVisible=true"
              style="margin-left: 10px">导入原料</a-button> -->
          </template>
        </a-page-header>
        <a-table :columns="columns"
                 :data-source="tableData"
                 :loading="loading"
                 :rowKey="(tableData) => tableData.id"
                 :pagination="pagination"
                 @change="handleTableChange">
          <template slot="link_url"
                    slot-scope="record">
            <img style="width: 50px; heigth: 50px"
                 :src="record.link_url"
                 alt />
          </template>
          <template slot="title"
                    slot-scope="record">
             {{ record.title }}
           </template>
          <template slot="type"
                    slot-scope="record">
            {{ record.batching_type?record.batching_type.title:'——' }}
          </template>

          <template slot="action"
                    slot-scope="record">
            <a-button type="link"
                      @click="showModal(record)" class="btn-diy" >编辑</a-button>
            <a-divider type="vertical" />
            <a-button type="link"
                      @click="deleteFn(record)" class="btn-diy">删除</a-button>
          </template>
        </a-table>
      </div>
    </div>

    <!-- 添加/编辑原料 -->
    <a-modal v-model="visible"
             :title="addBatching ? '添加原料' : '编辑原料'"
             :dialog-style="{ top: '20px' }"
             @ok="handleUpdate"
             :width="400"
             :okText="addBatching ? '新建' : '保存'">
      <a-form-model :model="batchingParam"
                    :rules="rules"
                    ref="batchingForm"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 18 }" style="max-height:500px;padding-right:10px;">
                    
        <a-form-model-item label="原料名称"
                           prop="title">
          <a-input v-model="batchingParam.title"
                   placeholder="请输入原料名称" />
        </a-form-model-item>
        <a-form-model-item label="原料类型" prop="batching_type_id">
          <a-select v-model="batchingParam.batching_type_id"
                    @change="selectBatching"
                    >
            <a-select-option value="" disabled>{{ '请选择原料类型' }}</a-select-option>
            <a-select-option v-for="item in batchingTypeData"
                             :key="item.id"
                             :value="item.id">{{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="原料单位"
                           prop="unit">
          <a-select v-model="batchingParam.unit"
                   placeholder="请选择原料单位">
            <a-select-option value="" disabled>{{ '请选择原料单位' }}</a-select-option>
            <a-select-option value="个">个</a-select-option>
            <a-select-option value="克">克</a-select-option>
          </a-select>
        </a-form-model-item>

      </a-form-model>
    </a-modal>
    <!-- 添加/编辑原料类型 -->
    <a-modal v-model="typeModalVisible"
             :title="addType ? '添加原料类型' : '编辑原料类型'"
             @ok="handleUpdateType"
             okText="保存">
      <a-form-model :model="typeParam"
                    :rules="typeRules"
                    ref="TypeForm"
                    :label-col="{ span: 7 }"
                    :wrapper-col="{ span: 14 }">
        <a-form-model-item label="类型名称"
                           prop="title">
          <a-input v-model="typeParam.title"
                   placeholder="请输入类型名称" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--复制原料前询问 -->
    <a-modal v-model="showDeleteOrSave"
             title="提示">
      复制成功后是否保留该原料?
      <template slot="footer">
        <a-button @click="deleteMealFn">删除</a-button>
        <a-button type="primary" @click="saveMealFn">保留</a-button>
      </template>
    </a-modal>

    <!-- 批量导入 -->
    <a-modal
      v-model="batchVisible"
      title="导入原料"
      okText="确定"
      cancelText="取消"
      @ok="handleBatch"
    >
      <a-form-model
        ref="batchForm"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="文件(请选择.xls格式)">
          <a-upload
            accept=".xls"
            @change="changeExcelFile"
            :before-upload="beforeExcelUpload"
            :file-list="excelFileList"
          >
            <a-button type="primary">
              <a-icon type="upload" />导入Excel
            </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="下载">
          <a-button type="primary" @click="handleDownloadTemplate"
            >模板下载</a-button
          >
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
//引入接口api
import {
  uploadImg,
  postDatalist,
  officeDatalist,
  mealDatalist,
  batchingTypeDatalist,
  batchingTypeAdd,
  batchingTypeEdit,
  batchingTypeRemove,

  batchingDatagrid,
  batchingAdd,
  batchingDetail,
  batchingEdit,
  batchingRemove,
  batchingCreate,
  batchingDelete,
  batchingExcelTemplate,
  batchingExcelImport
} from "@/request/api";
//引入封装的组件
import MyBreadcrumb from "@/components/common/MyBreadcrumb.vue";
//引入工具函数
import util from "@/utils/util";
function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    MyBreadcrumb,
  },
  data () {
    return {
      batchVisible: false,
      //传给MyBreadcrumb的参数
      breadcrumbs: [
        {
          key: 0,
          title: "用餐管理",
        },
        {
          key: 1,
          title: "原料管理",
        },
      ],

      //****原料列表相关参数
      queryParam: {
        page: 1,
        batching_type_id: "",
        title: ""
      },
      tableData: [], //从接口请求回来并在js部分整理好的表格数据
      loading: false, //table加载状态
      columns: [
        // 列配置
        {
          title: "名称",
          key: "title",
          className:'th-style',
          dataIndex: "title",
          // scopedSlots: { customRender: "title" },
        },
        {
          title: "单位",
          key: "unit",
          className:'th-style',
          dataIndex: "unit",
        },
        {
          title: "类型",
          key: "type",
          className:'th-style',
          scopedSlots: { customRender: "type" },
        },
        // {
        //   title: "添加时间",
        //   key: "created_at",
        //   className:'th-style',
        //   dataIndex: "created_at",
        // },
        {
          title: "操作",
          key: "action",
          className:'th-style',
          scopedSlots: { customRender: "action" },
        },
      ],
      pagination: {
        //页配置
        total: 0,
        pageSize: 10,
        current: 1,
      },
      visible: false,
      addBatching: false,
      batchingParam: {
        batching_type_id:'',
        title: "", //必填
        unit: "", //必填
        link_url: "",
      },
      mealTimesData: [],
      excelFileList: [],
      previewVisible: false,
      previewImage: "",
      rules: {
        title: [{ required: true, message: "请输入原料名", trigger: "blur" }],
        unit: [{ required: true, message: "请选择原料单位", trigger: "blur" }],
        batching_type_id: [{ required: true, message: "请选择原料类别", trigger: "blur" }]
      },
      fixedId: "",
      updateId: "",
      // disabled: false,

      //*****菜单类型相关配置
      batchingTypeData: [],
      columnsLeft: [
        {
          title: "名称",
          key: "title",
          scopedSlots: { customRender: "titleRender" },
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      typeModalVisible: false,
      addType: false,
      typeParam: {
        title: "",
      },
      typeRules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      searchTypeId: "",
      showTypes: false,
      TargetType: '',
      copy: {},
      copyed: {},
      isSave: false,
      copyParam: {},
      showReplenish: false,
      confirmLoading: false,
      confirmLoading2: false,
      showDeleteOrSave:false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //刷新
    reset () {
      this.queryParam = {
        page: 1,
        batching_type_id: this.searchTypeId,
        title: ''
      };
      this.pagination.current = 1;
      this.getTableData();
      // this.getBatchingType();
    },
    handleSearch(){
      this.queryParam.page = 1;
      this.pagination.current = 1;
      this.getTableData();
    },
    //获取表格数据
    getTableData () {
      this.loading = true;
      batchingDatagrid(this.queryParam).then((res) => {
        let resultData = res.data.result;
        const pagination = { ...this.pagination };
        pagination.total = resultData.total;
        this.pagination = pagination;
        //列表数据处理
        this.tableData = resultData.items.map((item) => {
          if(item.meals && item.meals.length>0){
            item.mealTimes = item.meals.map(item=>item.title).join("，");
          }else{
            item.mealTimes = '无'
          }
          
          return item;
        });
      }).finally(()=>{
        this.loading = false;
      });
    },

    //分页
    handleTableChange (pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.queryParam.page = pagination.current;
      this.getTableData();
    },

    //显示添加模态框
    showModal (record) {
      if (record == "add") {
        //添加
        this.addBatching = true;
        this.checkAllPost = true;
        this.batchingParam = {
          title: "", //必填
          unit: "", //必填
          batching_type_id: this.searchTypeId, //is_fixed=0时必选
          link_url: "",
        };
      } else {
        //编辑
        this.addBatching = false;
        this.updateId = record.id;
        batchingDetail({id:record.id}).then((res) => {
          let detail = res.data.result;
          this.batchingParam = {
            title: detail.title, //必填
            unit: detail.unit, //必填
            batching_type_id: detail.batching_type_id, 
            link_url: detail.link_url,
          };


        });
      }
      this.visible = true;
    },

    //选择原料类型
    selectBatching (val) {
      if (val == this.fixedId) {
        this.batchingParam.is_fixed = 1;
      } else {
        this.batchingParam.is_fixed = 0;
      }
    },



    //添加/编辑原料
    handleUpdate: util.DebounceBy(function () {
      this.$refs["batchingForm"].validate((valid) => {
        if (valid) {
          if (this.addBatching) {
            //添加
            batchingAdd(this.batchingParam)
              .then((res) => {
                if (res.data.result.id) {
                  this.$message.success("添加成功");
                  this.visible = false;
                  this.queryParam.page = 1;
                  this.pagination.current = 1;
                  this.getTableData();
                }
              })
              .catch((err) => {
                
              });
          } else {
            //编辑
            this.batchingParam.id = this.updateId
            batchingEdit(this.batchingParam)
              .then((res) => {
                this.$message.success("修改成功");
                this.visible = false;
                // this.queryParam.page = 1;
                // this.pagination.current = 1;
                this.getTableData();
              })
              .catch((err) => {
                
              });
          }
        }
      });
    }, 3000),


    saveMealFn(){
      //保留
      this.showDeleteOrSave = false
      this.isSave = true
      this.showTypes = true
      this.confirmLoading = false
    },

    deleteMealFn(){
      //删除
      this.showDeleteOrSave = false
      this.isSave = false
      this.showTypes = true
      this.confirmLoading = false
    },


    saveReplenish () {
      this.showReplenish = false
      this.$confirm({
        title:'提示',
        content:'复制成功后删除原原料,是否执行删除原料?',
        okText:'删除',
        onOk:  () => { 
          this.confirmLoading2 = true;
          batchingCreate(this.copyParam)
          .then((res) => {
            if (res.data.msg.indexOf("成功") != -1) {
              if (this.isSave == false) {
                batchingDelete(this.copy.id).then().catch(err => {
                  if (err.status == 204) {
                    this.confirmLoading2 = false;
                    this.$message.success('复制成功');
                    this.showReplenish = false;
                    this.queryParam.page = 1;
                    this.pagination.current = 1;
                    this.getTableData();
                  }
                })
              } else {
                this.confirmLoading2 = false;
                this.$message.success('复制成功');
                this.showReplenish = false;
                this.queryParam.page = 1;
                this.pagination.current = 1;
                this.getTableData();
              }
            }
          })
          .catch((err) => {
            if (err.status == 201) {
              if (this.isSave == false) {
                batchingDelete(this.copy.id).then().catch(err => {
                  if (err.status == 204) {
                    this.confirmLoading2 = false;
                    this.$message.success('复制成功');
                    this.showReplenish = false;
                    this.queryParam.page = 1;
                    this.pagination.current = 1;
                    this.getTableData();
                  }
                })
              } else {
                this.confirmLoading2 = false;
                this.$message.success('复制成功');
                this.showReplenish = false;
                this.queryParam.page = 1;
                this.pagination.current = 1;
                this.getTableData();
              }
            } else {
              let { errors } = err.data;
              for (let i in errors) {
                this.$message.error(errors[i][0]);
              }
            }
          });
        },
        onCancel: () => {
          this.isSave = true
          this.confirmLoading2 = true;
          batchingCreate(this.copyParam)
          .then((res) => {
            if (res.data.msg.indexOf("成功") != -1) {
              if (this.isSave == false) {
                batchingDelete(this.copy.id).then().catch(err => {
                  if (err.status == 204) {
                    this.confirmLoading2 = false;
                    this.$message.success('复制成功');
                    this.showReplenish = false;
                    this.queryParam.page = 1;
                    this.pagination.current = 1;
                    this.getTableData();
                  }
                })
              } else {
                this.confirmLoading2 = false;
                this.$message.success('复制成功');
                this.showReplenish = false;
                this.queryParam.page = 1;
                this.pagination.current = 1;
                this.getTableData();
              }
            }
          })
          .catch((err) => {
            if (err.status == 201) {
              if (this.isSave == false) {
                batchingDelete(this.copy.id).then().catch(err => {
                  if (err.status == 204) {
                    this.confirmLoading2 = false;
                    this.$message.success('复制成功');
                    this.showReplenish = false;
                    this.queryParam.page = 1;
                    this.pagination.current = 1;
                    this.getTableData();
                  }
                })
              } else {
                this.confirmLoading2 = false;
                this.$message.success('复制成功');
                this.showReplenish = false;
                this.queryParam.page = 1;
                this.pagination.current = 1;
                this.getTableData();
              }
            } else {
              let { errors } = err.data;
              for (let i in errors) {
                this.$message.error(errors[i][0]);
              }
            }
          });
        },
      })
      
      
    },

    //删除原料
    deleteFn (record) {
      let id = record.id,
        title = record.title;
      this.$confirm({
        title: `确定删除原料${title}？`,
        content: `原料被删除后，如有菜品使用此原料，将不再被统计，请谨慎操作。`,
        onOk: () => {
          batchingRemove({id})
            .then((res) => { 
              if(res.data.result>0){
                this.$message.success("删除成功");
                this.getTableData();
              }else{
                this.$message.error("删除失败，请联系客服");
              }
            });
        },
      });
    },

    //获取原料分类
    getBatchingType () {
      batchingTypeDatalist().then((res) => {
        let data = res.data.result;
        this.batchingTypeData = data;
        this.batchingTypeData.sort((a, b) => {
          if (a.is_fixed == 1) {
            return -1;
          }
        });
        this.batchingTypeData.map((item) => {
          if (item.is_fixed == 1) {
            this.fixedId = item.id;
            this.batchingParam.batching_type_id = item.id;
            this.queryParam.batching_type_id = item.id;
            this.searchTypeId = item.id;
            this.TargetType = item.id;
          }
        });
        this.getTableData();
      });
    },

    //原料列表查询
    searchByType (record) {
      this.queryParam = {
        page: 1,
        batching_type_id: record.id,
        title: ''
      };
      this.searchTypeId = record.id;
      this.pagination.current = 1;
      this.getTableData();
    },

    //打开原料类别模态框
    showTypeModal (record) {
      //添加
      if (record == "add") {
        this.addType = true;
        this.typeParam = {
          title: "",
        };
      } else {
        //编辑
        if (record.id == this.fixedId) {
          this.$message.info("固定餐不可编辑,不可删除");
          return;
        }
        this.addType = false;
        this.typeParam = {
          title: record.title,
          id: record.id,
        };
      }
      this.typeModalVisible = true;
    },

    //添加/编辑原料类型
    handleUpdateType: util.DebounceBy(function () {
      this.$refs["TypeForm"].validate((valid) => {
        if (valid) {
          if (this.addType) {
            //添加
            batchingTypeAdd(this.typeParam)
              .then((res) => { 
                if(res.data.result.id){
                  this.$message.success("添加成功");
                  this.typeModalVisible = false;
                  this.getBatchingType();
                }
              })
              .catch((err) => {
                
              });
          } else {
            //编辑
            batchingTypeEdit( this.typeParam )
              .then((res) => {
                this.$message.success("编辑成功");
                this.typeModalVisible = false;
                this.getBatchingType();
              })
              .catch((err) => {
                let { errors } = err.data;
                for (let i in errors) {
                  this.$message.error(errors[i][0]);
                }
              });
          }
        }
      });
    }, 3000),

    //删除原料类型
    deleteType (record) {
      let id = record.id,
        title = record.title;
      if (id == this.fixedId) {
        this.$message.info("固定餐不可编辑，不可删除");
        return;
      }
      this.$confirm({
        content: `确定删除【${title}】吗？`,
        onOk: () => {
          batchingTypeRemove({id})
            .then((res) => { 
              if(res.data.result>0){
                console.log(1111)
                this.$message.success("删除成功");
                this.getBatchingType();
              }else{
                console.log(2222)
                this.$message.error('删除失败');
              }
            })
            .catch((err) => {
              console.log(3333)
              // this.$message.error(err.data.message?err.data.message:'操作出错啦');
            });
        },
      });
    },

    //原料导入
    changeExcelFile (info) {
      let excelFileList = [...info.fileList];
      excelFileList = excelFileList.slice(-1);
      this.excelFileList = excelFileList;
    },
    beforeExcelUpload(file) {
      this.excelFileList = [...this.excelFileList, file];
      return false;
    },
    //模板下载
    handleDownloadTemplate() {
      batchingExcelTemplate().then((res) => {
        util.acceptFileStream(res.data, "导入原料模板.xls");
      });
    },
    //数据写入excel
    export2Excel() {
      var that = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/export2Excel"); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
        const tHeader = ["名称", "时段", "类型", "部门", "职务", "单位", "限报份数", "库存", "简介", "错误信息"]; // 导出的表头名信息
        const filterVal = ["title", "meal", "type", "unit"]; // 导出的表头字段名，需要导出表格字段名
        const list = that.exportArr;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "失败原料信息"); // 导出的表格名称，根据需要自己命名
      });
    },
    //格式转换
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //批量导入
    handleBatch() {
      if (this.excelFileList.length == 0) {
        this.$message.info("请先上传文件");
        return;
      }
      const formData = new FormData();
      formData.append("batching_file", this.excelFileList[0].originFileObj);
      batchingExcelImport(formData)
        .then((res) => {
          this.batchVisible = false;
          let data = res.data.result;
          this.$notification.open({
            message: `成功导入条数：${data.success_count}`,
            description: `${
              data.error_item.length == 0
                ? "失败条数：0"
                : "失败条数：" + data.error_item.length
            }`,
            duration: 0,
          });

          if (data.error_item.length != 0) {
            this.exportArr = data.error_item;
            this.export2Excel();
          }
        })
        .catch((err) => {
          this.batchVisible = false;
          this.$notification.open({
            message: "导入失败",
            description: err.data.msg,
            duration: 0,
          });
        });
    },
    // customRow (record, index) {
    //   return {
    //     on: {
    //       //鼠标单击行
    //       click: event => {
    //         console.log(record.title)
    //         this.searchByType(record);
    //       }
    //     }
    //   }
    // }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  async created () {
    await this.getBatchingType();
    // this.getTableData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
  beforeCreate () { }, //生命周期 - 创建之前
  beforeMount () { }, //生命周期 - 挂载之前
  beforeUpdate () { }, //生命周期 - 更新之前
  updated () { }, //生命周期 - 更新之后
  beforeDestroy () { }, //生命周期 - 销毁之前
  destroyed () { }, //生命周期 - 销毁完成
  activated () { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  padding-top: 53px;
  .mainBox {
    background-color: #f0f2f5;
    .show_left {
      background-color: white;
      width: 250px;
      padding: 0 10px;
      position: absolute;
      height: calc(92vh - 53px);
      overflow: auto;
    }
    .show_right {
      background-color: white;
      padding: 0 10px;
      width: calc(100% - 260px);
      float: right;
    }
  }
}
.btn-diy{
  padding:0;
}
</style>
<style>
.th-style{
  padding-left:2px!important;
  padding-right:0!important;
  text-align: center!important;
  font-size: 12px!important;
}
</style>